var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zy_media"},[_c('video',{attrs:{"poster":_vm.cover,"data-config":"{\"mediaTitle\": \"《疯狂动物城》--腾讯视频\"}"}},[_c('source',{attrs:{"src":_vm.video,"type":"video/mp4"}}),_vm._v(" 您的浏览器不支持HTML5视频 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }